exports.install = function (Vue, options) {
	Vue.prototype.tool = {
		/**
		 * 去除空格
		 * @param  {String} str [要去除的字符串]
		 * @param  {String} loc [去除的位置]
		 * @return {[type]}     [返回去除空格后的字符串]
		 */
		trim:function(str="",loc="all"){
			let reg = /\s*/g;
			switch(loc){
				case "both":
					reg = /^\s*|\s*$/g;
					break;
				case "left":
					reg = /^\s*/g;
					break;
				case "right":
					reg = /(\s*$)/g;
					break;
				default:
					break;
			}

			return str.replace(reg,"");
		}
	};
};


// WEBPACK FOOTER //
// ./src/config/tool.js